// extracted by mini-css-extract-plugin
export default {"header":"profiles_header__iz5mY","user":"profiles_user__ORlUs","negativeMargin":"profiles_negativeMargin__agyAl"};